//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular, {IWindowService} from 'angular';
import _ from 'underscore';

export default class ExperimentsService {
  constructor(
        private $window: IWindowService,
    ) {
    this.$window.crl8.activeExperiments = this.$window.crl8.activeExperiments || [];
  }

  public setExperimentIsActive(experimentName: string, isActive: boolean) {
    const idx = this.$window.crl8.activeExperiments.indexOf(experimentName);
    if (idx < 0 && isActive) {
      this.$window.crl8.activeExperiments.push(experimentName);
    } else if (idx >= 0 && !isActive) {
      this.$window.crl8.activeExperiments = _(this.$window.crl8.activeExperiments).reject((experiment) => {
        return experiment === experimentName;
      });
    }
  }

  public getActiveExperiments(): string[] {
    if (_.isEmpty(this.$window.crl8.activeExperiments)) {
      return undefined;
    } else {
      return angular.copy(this.$window.crl8.activeExperiments);
    }
  }
}

angular.module('curalate').service('ExperimentsService', [
  '$window',
  ExperimentsService,
]);
